import poweredBySvg from 'icons/poweredBy.svg';
import { ENGT_CHAT } from 'js/bot.model';
import './poweredBy.scss';

export const PoweredByTemplate = (model) => {
	let poweredByHtml = '';
	if (ENGT_CHAT.get('config.brand_name') === 'Engati') {
		poweredByHtml = `<div class="engt-powered">
            <div class="engt-powered-text"><img src=${poweredBySvg} /><a href=${model.url} target="_blank" class="poweredByLink">${model.poweredBy}&nbsp;${model.brand}</a>	</div>
			</div>`;
	} else if (model.brand && model.url) {
		poweredByHtml = `<div class="engt-powered">
            <div class="engt-powered-text"><a href=${model.url} target="_blank" class="poweredByLink">${model.brand}</a>	</div>
			</div>`;
	} else {
		poweredByHtml = '';
	}

	return !ENGT_CHAT.get('config.remove_branding') ? poweredByHtml : '';
};
